export default "__VITE_ASSET__Dcq0ym$b__"